export default __webpack_public_path__ + "static/media/pointer.77944e1c.svg";